import { TailwindWrapper } from "@utils/TailwindWrapper";
import { Text } from "@ui-component-library";

import AtlLogo from '@assets/partners/ATL.svg';
import LudvigLogo from '@assets/partners/LudvigCO.svg';
import SvenskaKyrkanLogo from '@assets/partners/SvenskaKyrkan.svg';
import GoteborgsStadLogo from '@assets/partners/GoteborgsStad.svg';
import KronobergsLansstyrelseLogo from '@assets/partners/LansstyrelsenKronoberg.svg';
import SFVLogo from '@assets/partners/SFV.svg';
import NorskSkogbrukLogo from '@assets/partners/NorskSkogsbruk.svg';
import SEBLogo from '@assets/partners/SEB.svg';
import MotalaKommunLogo from '@assets/partners/MotalaKommun.svg';

import BerkleyLogo from '@assets/partners/BerkleyNordic.png';
import SakraLogo from '@assets/partners/Sakra.png';
import ArbonicsLogo from '@assets/partners/Arbonics.png';

const PartnerSection = () => {

  const logos = [AtlLogo, LudvigLogo, SvenskaKyrkanLogo, GoteborgsStadLogo, KronobergsLansstyrelseLogo, SFVLogo, BerkleyLogo, SakraLogo, NorskSkogbrukLogo, ArbonicsLogo, SEBLogo, MotalaKommunLogo];
  const scrollingLogos = [...logos, ...logos];
  
  return (
    <TailwindWrapper>
      <section className='container my-12'>
        <Text variant="text-sm/leading-normal/normal" className="text-center text-[#737373] mb-8">Våra samarbetspartners</Text>
        <div
          className="overflow-x-hidden"
          style={{
            WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)',
            maskImage: 'linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)',
          }}
        >
          <div className="animate-partner-logo-scroll flex w-max items-center gap-6">
            {scrollingLogos.map((Logo, index) => (
              <div key={index} className="flex h-[74px] w-auto shrink-0 items-center px-9 py-2.5 pr-6 grayscale">
                {typeof Logo === 'string' ? <img src={Logo} alt={`Partner ${(index % logos.length) + 1}`} className={`h-[54px] w-auto object-contain`} /> : <Logo height={54} />}
              </div>
            ))}
          </div>
        </div>
      </section>
    </TailwindWrapper>
  );
};

export default PartnerSection;
